export const FacebookIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="3"
                stroke={activeColor}
                strokeWidth="2"
            />

            <path
                d="M14 8H13C12.4477 8 12 8.44772 12 9V11H14V13H12V17"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}